import { injectable, inject } from 'inversify';

import * as signalR from 'signalr-no-jquery';
import { ConfigurationService } from './configuration.service';
import { IdentityService } from 'src/core/services/identity.service';
import EventEmitter from './event-emitter';

@injectable()
export class CommunicationService {

	@inject(ConfigurationService)
	private configService: ConfigurationService;

	@inject(IdentityService)
	private identity: IdentityService;

	private _eventEmitter: EventEmitter;
	private _connection: signalR.Connection;
	private _proxy: signalR.Proxy;

	private _initialized: boolean;
	private _reconnecting: boolean;
	private time = 10;

	interval: any;

	constructor() {
		this._eventEmitter = new EventEmitter();
		this._initialized = false;
	}

	public get EventEmitter(): EventEmitter {
		return this._eventEmitter;
	}

	public setup = async () => {

		this._connection = signalR.hubConnection(`${this.configService.configuration.serviceUrl}`);

		this._proxy = this._connection.createHubProxy("NotificationHub");

		this._proxy.on("showInfo", this.showInfo);
		this._proxy.on("logMessage", this.logMessage);
		this._proxy.on("entityChange", this.entityChange);

		this.initialize();

		(this._connection as any).disconnected((e) => {
			if (!this._reconnecting) {

				console.log(`SignalR disconnection`);
				//this._eventEmitter.emit("connectionStatus", { connected: false, time: this.time });
				console.log("SignalR setup service again");

				//if (!!this.interval)
				//	clearInterval(this.interval);

				this.setup();
				this._reconnecting = true;
			}
		});


		this._proxy.on("closed", error => {
			console.log(`SignalR error: ${error}`);
			this._eventEmitter.emit("connectionStatus", { connected: false, time: this.time });
			console.log("SignalR: trying to connect...");
			this._initialized = false;
			this.interval = setTimeout(() => {
				this.initialize();
			}, this.time * 1000); // Restart connection after 0,5 seconds.
		});
	}

	private entityChange = (data) => {
		this._eventEmitter.emit("entityChange", data);
	}

	private logMessage = (date, message, level) => {
		this._eventEmitter.emit("logMessage", date, message, level);
	}

	private showInfo = (title, message, type) => {
		this._eventEmitter.emit("showInfo", title, message, type);
	}

	private initialize = () => {
		(this._connection as any).qs = {
			userId: this.identity.userId
		};

		this._connection
			.start({ jsonp: true })
			.done(() => {
				this._initialized = true;
				console.log('SignalR: Connection started!');
				this._eventEmitter.emit("connectionStatus", { connected: true, time: 0 });

				if (!!this.interval)
					clearInterval(this.interval);

				this._reconnecting = false;
			})
			.fail(err => {
				console.error(`SignalR error: ${err}`);
				this._eventEmitter.emit("connectionStatus", { connected: false, time: this.time, err });
				console.log('SignalR: Error while establishing connection :(');
				this.interval = setTimeout(() => {
					this.initialize();
				}, this.time * 1000); // Restart connection after 1 seconds.
			});
	}

}



// WEBPACK FOOTER //
// ./src/core/services/communication.service.ts